module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_vm._m(0), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("群星资讯 Newsroom")]), _vm._v(" "), _c('div', {
    staticClass: "main news-001"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485957&idx=1&sn=aea677a51a47a5dd56cee9eee3dd7fe9&chksm=f962563ece15df28df9975f4fcbed012f7cf1a0793aaac69650adb85611b668237204dadc2d8&mpshare=1&scene=1&srcid=0114kqQ5PHpXrNI0OWgPjJ1u&key=c00f467f1168649cfd1e4209437e7eed81435b5bc8b90af1c6a74fea8e7114338e502dc9183e6290db7e8e3f5598c1ac7913bb30f2b465f9080d407e817b2bb97fb68a624cb26aec9bf52136e737d162&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h2', [_vm._v("2018年全国及各省市供应链金融政策汇总及解读")]), _vm._v(" "), _c('h3', [_vm._v("党中央、国务院高度重视供应链金融工作，围绕供应链金融发展问题国家各部门制定出台了一系列政策措施，将供应链金融作为金融领域改革的重要内容。")]), _vm._v(" "), _c('h5', [_vm._v("2019年1月13日")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-002"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485631&idx=1&sn=e52b19b585c35f0583ef884fe85d5910&chksm=f9625484ce15dd924ecd0779f4594e961945f0347138e955d8ab7e1cf44fee654d4d429ddfc8&mpshare=1&scene=1&srcid=0114Mvl27fSTUXxsZamGoloL&key=bec5e629de7c44219c115bb750613e4bd74c9bb63046873a43ed0e8c47148737bb0f1e6cdf2e3cce7b54524baca63d671db3d4f7482aff8e6982e10dded9fa2e759da06c3641629eb834851170cda623&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("供应链金融—美国的昨天、日本的今天、中国的明天")]), _vm._v(" "), _c('h3', [_vm._v("2018年11月02日")]), _vm._v(" "), _c('h5', [_vm._v("供应链金融起源来自于供应链管理，传统的供应链管理强调“6R”，即将顾客所需的正确的产品能够在正确的时间、按照正确的数量、正确的质量……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-003"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485705&idx=1&sn=d7eb0fde9f8d9465cb7232cd5d2cbc1f&chksm=f9625532ce15dc241317ffbfd639f2451cb9e0a10a57d97b07d371ad10ae6f4be16318b33bbf&mpshare=1&scene=1&srcid=0114Zf6Hye1NxBAya8NaKE1Z&key=908e15f391718e2fea8bf2c3623de3bf84d927c05409e9804f406f99f4f91784bcc8c98df421604ef6bed834d4f1ac43f27b7235e4030b0416fe3e2c920d7dd89958482f67c693b63a2cd6ce5cd0e454&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("2018年供应链金融行业发展趋势报告")]), _vm._v(" "), _c('h3', [_vm._v("2018年11月21日")]), _vm._v(" "), _c('h5', [_vm._v("2018年，供应链金融成了资本眼中的“风口”，一时间，大量企业都蜂拥而至。客观来看，它是实现上至国家、下至地方企业经济转型的重要突破……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-004"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485442&idx=1&sn=4bb95b10d9bdb2561886d6804ba17ff4&chksm=f9625439ce15dd2f077e2757f9b9a37f0623aeb5e63fdd675a4330336a937a2bf9a63ec7de2f&mpshare=1&scene=1&srcid=01145kLicotPb7yuUreg2Tcm&key=97a5648ff70ea34209722cc0c3d3d72edeef8494a7b655b860453f7bd536f0818ee12a5d0dba54a0f524e2b9042b17550e9f5848a72f7f4a01f30b2660355ff35682471c705091dd63c4c2cf08eae541&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("物流领域12大商业模式")]), _vm._v(" "), _c('h3', [_vm._v("2018年09月18日")]), _vm._v(" "), _c('h5', [_vm._v("“真正从运输、仓储运营中赚点辛苦钱”，这是中国物流基层的商业模式，那些跑在路上的卡车司机、蹲在仓库做传统的物流服务模式的企业，这……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-005"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485009&idx=1&sn=eb7c990a9a26ef21c776ce134714e17d&chksm=f9625a6ace15d37c90567cf7d8359b5a1bc8563d9c0b1af886cc471120539e768afe36d5c30a&mpshare=1&scene=1&srcid=0114jOOHCu8Y9185lLyqYSDt&key=bd6a952ad1769e3ed4b2eb227cc31be2601d64bc84adc6c0350868b91b8b45c5cc8ca96628927c5b5b67d75fea19016950506db407b422fd14b408af5df54dd68a11fff6938bd4d06b16239127d95d86&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("生日快乐呀，群小星！")]), _vm._v(" "), _c('h3', [_vm._v("2018年06月28日")]), _vm._v(" "), _c('h5', [_vm._v("今天是群小星的生日，倏忽间群星金融已经诞生整整五年了。群星“航母”里面的小伙伴们来来又走走。有些人过来推了我一把又离去，成了……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-006"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247484760&idx=1&sn=1cd4e359d2f2e2777c5967261da866fe&chksm=f9625963ce15d075e02a7ff1a24e6b24752490df554ffa08f2c4f97a46b312954affdec74f05&mpshare=1&scene=1&srcid=0114jOIR0TcRDNE775H6f3Ta&key=1af80038efb38668453b118f6affb25c0de89e54e9334a3bf7ecfb575da02c4d2223a76a9125c4e7f5e944bc39013503c1c5196dd52d2fbaa2a84a5192d0b74b2c9d37c9e86bcbc3e9c1984cd055b68f&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("建筑产业链遇上供应链金融，实现多方持续共赢")]), _vm._v(" "), _c('h3', [_vm._v("2018年05月17日")]), _vm._v(" "), _c('h5', [_vm._v("5月11日的界面资本论坛上，华建集团副总裁周静瑜受邀出席圆桌论坛，阐述了4年前对一家位列全球前三的美国室内设计公司——威尔逊……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-007"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247484593&idx=1&sn=a89329d4b9bd2e8f39f9be00f6c0ab2f&chksm=f962588ace15d19caf7953e1286b044f76327cff0ef62f6e24f16463cc88b2c1e4b3eeeeec75&mpshare=1&scene=1&srcid=0114VqJazvBG5Fu4w3yqXmjj&key=fdbd38954fdfc514a886025914e1549f2481cd624fcf90d9bbf0211757d34e7d65e0d63b3d1e07ef8e2f8c341a25297dffd09abf1a87e61aaf0f471aaaa747c735679892a7de4459ebaa99e734d61068&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("一个五年前就开始布的局")]), _vm._v(" "), _c('h3', [_vm._v("2018年04月26日")]), _vm._v(" "), _c('h5', [_vm._v("京东、苏宁、腾讯对供应链金融的重视和布局，充分显示出沉寂一年多的供应链金融出现了回暖的趋势。无论是传统商业银行、行业龙头、物流公……")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5515e29f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/News.vue
// module id = 1331
// module chunks = 26